import '.ae{flex:1 1 0;}.ssr-plugin'
import '.gv{border-radius:var(--border-radius-image);}.ssr-plugin'
import '.iu{background-color:var(--palette-steady-stone);}.ssr-plugin'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { Image } from '@app/components/core/image/Image'

export type LandingContentImageColumnProps = {
  imageSrc?: string
  imageAlt?: string
}

const LandingContentImageColumn = ({
  imageSrc,
  imageAlt = '',
}: LandingContentImageColumnProps) => {
  const isMobile = useMediaQuery()

  const frameHeight = isMobile ? '21rem' : '31rem'

  return imageSrc ? (
    <div className="ae gv"
      style={{
        height: frameHeight,}}
    >
      <Image
        src={imageSrc}
        alt={imageAlt}
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  ) : (
    <div className="ae gv iu"
      style={{
        minHeight: isMobile ? '20.5rem' : '30.5rem',}}
    />
  )
}

export default LandingContentImageColumn
